import Client from './clients'
import Home from './home'
import Order from './order'
import Plan from './plan'
import User from './user'

const routes = [...Home, ...Order, ...Client, ...Plan, ...User]

export default routes
